import React from 'react';
import { volumes } from '../data/volumes';
import { SectionLabel } from './ui/SectionLabel';
export function LibrarySection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="library-heading" data-id="element-108" data-mp="23cai30lpl8x6">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-109" data-mp="2hbs8tlikew96">
        <div className="mx-auto max-w-2xl text-center" data-id="element-110" data-mp="2daq44p5vprzt">
          <div className="flex justify-center" data-id="element-111" data-mp="2d95endyf8z8t">
            <SectionLabel data-id="element-112" data-mp="1pmgpq8azw6ip">The library</SectionLabel>
          </div>
          <h2 id="library-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-113" data-mp="1kmknadhy4n59">
            120 Ready-to-Teach classes.
            <span className="block text-forest" data-id="element-114" data-mp="1tmh7a1te4xtz">6 professional volumes.</span>
          </h2>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-3" data-id="element-115" data-mp="15wmrbbdryt5i">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col items-center rounded-2xl border border-sandDark bg-ivory p-2.5 text-center sm:p-3.5" data-id="element-116" data-mp="11v1lg9znrf4t">
              <div className="flex flex-wrap items-center justify-center gap-x-1.5" data-id="element-117" data-mp="12emzxf0sb625">
                <p className="text-[0.52rem] font-semibold uppercase tracking-label text-gold" data-id="element-118" data-mp="176ej34hm29i9">
                  Volume {volume.number}
                </p>
                <span className="text-sandDark" aria-hidden="true" data-id="element-119" data-mp="1c7lnctkjoqk6">
                  ·
                </span>
                <p className="text-[0.52rem] font-semibold uppercase tracking-label text-forest" data-id="element-120" data-mp="jh3k9sjtmp6r">
                  {volume.classes}
                </p>
              </div>
              <img src={volume.cover} alt={`Volume ${volume.number}: ${volume.title}`} className="mt-2 w-20 rounded-md sm:w-24" width={900} height={1200} loading="lazy" data-id="element-121" data-mp="oi9i24sc92n5" />
              <h3 className="mt-2 font-serif text-[0.8rem] font-semibold uppercase leading-tight text-ink sm:text-[0.92rem]" data-id="element-122" data-mp="24sva5rzr3qvk">
                {volume.title}
              </h3>
              <p className="mt-1 text-[0.7rem] leading-snug text-muted sm:text-[0.8rem]" data-id="element-123" data-mp="3vxf074vvhhfk">
                {volume.description}
              </p>
            </li>)}
        </ul>

        <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-gold/30 bg-ivory px-5 py-3 text-center text-[0.62rem] font-semibold uppercase tracking-label text-muted sm:text-xs" data-id="element-124" data-mp="9qqlq8skz99p">
          <span data-id="element-125" data-mp="3d9a4mkpdd2ru">6 Volumes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-126" data-mp="3d65p4r6geklv">
            ×
          </span>
          <span data-id="element-127" data-mp="3r1hv5uq27xi3">20 Classes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-128" data-mp="3m8x430yjfyi9">
            =
          </span>
          <span className="text-forest" data-id="element-129" data-mp="2yj2sempygfzl">120 Ready-to-Teach Classes</span>
        </p>
      </div>
    </section>;
}